import React from 'react';
import {connect} from 'react-redux';
import {checkPermission} from '~/utils/permissions';

const mapStateToProps = (state) => ({
    permissions: state.context.permissions
});

export const Permission = connect(mapStateToProps)(({
    permissions,
    group,
    permission = [],
    children
}) => {
    return checkPermission(permissions, group, permission) ? (
        children
    ) : null;
});
